import { FetchArgs } from '@reduxjs/toolkit/dist/query/fetchBaseQuery'
import { BaseQueryApi, fetchBaseQuery } from '@reduxjs/toolkit/dist/query/react'

import { checkCache, readFromCache } from 'src/core/classes/cache/Cache'
import { getIdentityTokens, getTokens } from 'src/core/classes/helpers/StorageHelper'
import { authService } from 'src/core/classes/services/AuthService'
import settings from 'src/core/config/hostConfig'

interface ICustomQuery {
  storageKey: string
  baseUrl: string
  cachedUrl?: { url: string; method: 'GET' | 'POST' | 'PUT' | 'DELETE' }[]
  useOldToken?: boolean
}

export const getCustomQuery = ({
  storageKey,
  baseUrl,
  cachedUrl,
  useOldToken = false,
}: ICustomQuery) => {
  return async (arg: string | FetchArgs, api: BaseQueryApi) => {
    const fetchUrl = (arg as FetchArgs).url || (arg as string)
    const fetchMethod = (arg as FetchArgs).method || 'GET'
    const needCache = cachedUrl
      ? !!cachedUrl.find((el) => el.url === fetchUrl && el.method === fetchMethod)
      : true
    const needRefresh = checkCache(storageKey)

    if (!needRefresh && needCache) {
      const data = readFromCache(storageKey)
      return { data }
    }

    const result = fetchBaseQuery({
      baseUrl,
      prepareHeaders: async () => {
        const [identityToken] = getIdentityTokens()

        if ((identityToken || settings.notExchangeToken) && !useOldToken) {
          await authService.checkIdentityToken()
        } else {
          await authService.checkToken(true)
        }

        const myHeaders = new Headers()

        myHeaders.append('Content-Type', 'application/json; charset=UTF-8')
        const [token] = (identityToken || settings.notExchangeToken) && !useOldToken ? getIdentityTokens() : getTokens()
        if (token) {
          myHeaders.append('Authorization', `Bearer ${token}`)
        }
        return myHeaders
      },
    })
    return result(arg, api, {})
  }
}
